var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormPanel',{attrs:{"headline":"Create Content Article Category","errors":_vm.errors,"initial":{content_bodies: []}},on:{"submit":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }